import { RTL_UI_LANGUAGES, UI_LANGUAGES, type UiLanguage } from '@unipostudio/shared-types';

/**
 * The languages the UI ships in (UI_LANGUAGES in shared-types, the list the
 * API accepts for a user's language and the worker writes emails in). Kept
 * free of any i18next import so hooks, helpers and tests can read the list
 * without initialising i18n. Each entry needs a matching file in ./locales;
 * the loader fetches it on demand.
 */
export const SUPPORTED_LANGUAGES = UI_LANGUAGES;

export type SupportedLanguage = UiLanguage;

export const RTL_LANGUAGES: readonly SupportedLanguage[] = RTL_UI_LANGUAGES;

export function isRtlLanguage(language: string): boolean {
  return (RTL_LANGUAGES as readonly string[]).includes((language || '').split('-')[0] ?? '');
}
